import React from 'react';
import {t} from '@lingui/core/macro';

import FiltersModal from 'shared/ui/Modal/FiltersModal/FiltersModal';
import {FILTERS_KEPT_NONE} from 'shared/lib/filterHelper';

import DomainIncidentsExportFormHandler from './DomainIncidentsExportFormHandler';

interface IDomainIncidentsExportModalProps {
    open: boolean,
    handleClose: () => void,
}

const DomainIncidentsExportModal: React.FC<IDomainIncidentsExportModalProps> = ({open, handleClose}) => (
    <FiltersModal
        header={t`Экспорт инцидентов доменов`}
        open={open}
        handleClose={handleClose}
        keepParams={FILTERS_KEPT_NONE}
        withReset={false}
    >
        <DomainIncidentsExportFormHandler handleClose={handleClose}/>
    </FiltersModal>
);

export default DomainIncidentsExportModal;
